var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "btn-group btn-group-sm mb-2",
          attrs: { "data-toggle": "buttons" }
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-success",
              attrs: {
                type: "button",
                "data-toggle": "modal",
                "data-target": "#addModal"
              }
            },
            [_vm._v(_vm._s(_vm.$t("btnAdd")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-danger",
              attrs: {
                disabled: _vm.selectedIndex.length !== 1,
                id: "deleteBtn",
                "data-toggle": "modal",
                "data-target": "#confirmModal"
              }
            },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.$t("btnDelete")) + "\n        "
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("vue-good-table", {
        attrs: {
          columns: _vm.columnsConfig,
          rows: _vm.oeeSettingsPage,
          "pagination-options": {
            enabled: true,
            nextLabel: _vm.$t("txtNext"),
            prevLabel: _vm.$t("txtPrev"),
            rowsPerPageLabel: _vm.$t("txtPagePer"),
            ofLabel: _vm.$t("txtOf"),
            pageLabel: _vm.$t("txtPage"),
            allLabel: _vm.$t("txtAll")
          },
          "select-options": _vm.selectConfig,
          "search-options": { enabled: true, placeholder: _vm.$t("txtSearch") }
        },
        on: { "on-selected-rows-change": _vm.selectionChanged }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "addModal",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "myModalLabel"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-lg",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "h4",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "myModalLabel" }
                    },
                    [_vm._v(_vm._s(_vm.$t("txtOeeShift")))]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("table", { staticClass: "table" }, [
                    _c("thead", { staticClass: "table-primary" }, [
                      _c("tr", [
                        _c("td", [
                          _c("small", [
                            _vm._v(
                              _vm._s(_vm.$t("txtOeeShift")) +
                                " 1: " +
                                _vm._s(_vm.$t("txtOeeShiftHour"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newSetting.hour,
                                expression: "newSetting.hour"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text" },
                            domProps: { value: _vm.newSetting.hour },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newSetting,
                                  "hour",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("small", [
                            _vm._v(_vm._s(_vm.$t("txtOeeShiftMin")))
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newSetting.min,
                                expression: "newSetting.min"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text" },
                            domProps: { value: _vm.newSetting.min },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newSetting,
                                  "min",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("small", [
                            _vm._v(
                              _vm._s(_vm.$t("txtOeeDefaultProductionTimeMin"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.newSetting
                                    .defaultPlannedProductionTimeMin,
                                expression:
                                  "newSetting.defaultPlannedProductionTimeMin"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text" },
                            domProps: {
                              value:
                                _vm.newSetting.defaultPlannedProductionTimeMin
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newSetting,
                                  "defaultPlannedProductionTimeMin",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _c("small", [
                            _vm._v(
                              _vm._s(_vm.$t("txtOeeShift")) +
                                " 2: " +
                                _vm._s(_vm.$t("txtOeeShiftHour"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newSetting.hour2,
                                expression: "newSetting.hour2"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text" },
                            domProps: { value: _vm.newSetting.hour2 },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newSetting,
                                  "hour2",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("small", [
                            _vm._v(_vm._s(_vm.$t("txtOeeShiftMin")))
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newSetting.min2,
                                expression: "newSetting.min2"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text" },
                            domProps: { value: _vm.newSetting.min2 },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newSetting,
                                  "min2",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("small", [
                            _vm._v(
                              _vm._s(_vm.$t("txtOeeDefaultProductionTimeMin"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.newSetting
                                    .defaultPlannedProductionTimeMin2,
                                expression:
                                  "newSetting.defaultPlannedProductionTimeMin2"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text" },
                            domProps: {
                              value:
                                _vm.newSetting.defaultPlannedProductionTimeMin2
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newSetting,
                                  "defaultPlannedProductionTimeMin2",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _c("small", [
                            _vm._v(
                              _vm._s(_vm.$t("txtOeeShift")) +
                                " 3: " +
                                _vm._s(_vm.$t("txtOeeShiftHour"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newSetting.hour3,
                                expression: "newSetting.hour3"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text" },
                            domProps: { value: _vm.newSetting.hour3 },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newSetting,
                                  "hour3",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("small", [
                            _vm._v(_vm._s(_vm.$t("txtOeeShiftMin")))
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newSetting.min3,
                                expression: "newSetting.min3"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text" },
                            domProps: { value: _vm.newSetting.min3 },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newSetting,
                                  "min3",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("small", [
                            _vm._v(
                              _vm._s(_vm.$t("txtOeeDefaultProductionTimeMin"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.newSetting
                                    .defaultPlannedProductionTimeMin3,
                                expression:
                                  "newSetting.defaultPlannedProductionTimeMin3"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text" },
                            domProps: {
                              value:
                                _vm.newSetting.defaultPlannedProductionTimeMin3
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newSetting,
                                  "defaultPlannedProductionTimeMin3",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tbody", [
                      _c("tr", [
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newSetting.name,
                                expression: "newSetting.name"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t("txtName")
                            },
                            domProps: { value: _vm.newSetting.name },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newSetting,
                                  "name",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("date-picker", {
                              attrs: { "bootstrap-styling": true },
                              on: { selected: _vm.onClick },
                              model: {
                                value: _vm.start,
                                callback: function($$v) {
                                  _vm.start = $$v
                                },
                                expression: "start"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      attrs: { type: "button", "data-dismiss": "modal" }
                    },
                    [_vm._v("Close")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function($event) {
                          return _vm.postSetting()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("btnSave")))]
                  )
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "confirmModal",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "myModalLabel"
          }
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog", attrs: { role: "document" } },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "h4",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "myModalLabel" }
                    },
                    [_vm._v(_vm._s(_vm.$t("txtDelete")))]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("txtOeeDelete")) +
                        "\n                    "
                    ),
                    _vm._l(_vm.selectedIndex, function(item, index) {
                      return _c("div", [
                        _c("span", [_vm._v(_vm._s(item.name))])
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      attrs: { type: "button", "data-dismiss": "modal" }
                    },
                    [_vm._v(_vm._s(_vm.$t("btnClose")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function($event) {
                          return _vm.deleteSelected()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("btnDelete")))]
                  )
                ])
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }